import { Link } from "react-router-dom";
import { Phone, MapPin, Instagram, Facebook, Mail } from "lucide-react";
import { ACADEMY, NAV_LINKS } from "../lib/academy-data";

export default function Footer() {
  return (
    <footer className="bg-[#050505] border-t border-white/10 mt-20" data-testid="footer">
      <div className="container mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div className="flex flex-col gap-4">
            <Link to="/" className="flex items-center gap-3" data-testid="footer-logo">
              <img
                src={ACADEMY.logo}
                alt="הפועל מטה יהודה"
                className="h-14 w-14 object-contain"
              />
              <div className="flex flex-col leading-tight">
                <span className="font-heading font-black text-lg text-white uppercase">
                  האקדמיה
                </span>
                <span className="font-body text-xs text-neutral-400">
                  הפועל מטה יהודה
                </span>
              </div>
            </Link>
            <p className="font-body text-sm text-neutral-400 leading-relaxed max-w-xs">
              {ACADEMY.tagline}. מיועד ל{ACADEMY.audience}.
            </p>
            <div className="flex gap-3 mt-2">
              <a
                href={ACADEMY.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="w-10 h-10 inline-flex items-center justify-center border border-white/15 hover:border-[#DC2626] hover:bg-[#DC2626] text-white transition-all rounded-sm"
              >
                <Instagram size={18} strokeWidth={2.5} />
              </a>
              <a
                href={ACADEMY.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                data-testid="footer-facebook"
                className="w-10 h-10 inline-flex items-center justify-center border border-white/15 hover:border-[#DC2626] hover:bg-[#DC2626] text-white transition-all rounded-sm"
              >
                <Facebook size={18} strokeWidth={2.5} />
              </a>
            </div>
          </div>

          {/* Nav */}
          <div>
            <h4 className="font-heading text-sm font-bold tracking-widest text-[#DC2626] uppercase mb-5">
              ניווט
            </h4>
            <ul className="flex flex-col gap-3">
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="font-body text-sm text-neutral-300 hover:text-white transition-colors"
                    data-testid={`footer-link-${link.to.replace("/", "") || "home"}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-sm font-bold tracking-widest text-[#DC2626] uppercase mb-5">
              פרטי קשר
            </h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3 font-body text-sm text-neutral-300">
                <MapPin size={18} strokeWidth={2.5} className="text-[#DC2626] flex-shrink-0 mt-0.5" />
                <span>{ACADEMY.location}</span>
              </li>
              <li className="flex items-start gap-3 font-body text-sm text-neutral-300">
                <Phone size={18} strokeWidth={2.5} className="text-[#DC2626] flex-shrink-0 mt-0.5" />
                <a
                  href={`tel:${ACADEMY.managerPhone.replace(/-/g, "")}`}
                  className="hover:text-white transition-colors"
                  data-testid="footer-phone"
                  dir="ltr"
                >
                  {ACADEMY.managerPhone}
                </a>
              </li>
              <li className="flex items-start gap-3 font-body text-sm text-neutral-300">
                <Mail size={18} strokeWidth={2.5} className="text-[#DC2626] flex-shrink-0 mt-0.5" />
                <span>{ACADEMY.manager} — {ACADEMY.managerRole}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="font-body text-xs text-neutral-500">
            © {new Date().getFullYear()} {ACADEMY.name}. כל הזכויות שמורות.
          </p>
          <p className="font-body text-xs text-neutral-500">
            בשיתוף מועצה אזורית מטה יהודה ובית הספר החקלאי עין כרם
          </p>
        </div>
      </div>
    </footer>
  );
}
